import React from 'react';
import { Modal, Button, Form, Row, Col, DatePicker, message } from 'antd';
import { _getDate } from 'lib/Helper';
import { SelectRombel, SelectSemester, SelectStatusNotif, SelectTahunAjaran } from 'components/select';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const ModalFilter = ({ values, visible, hideModal, setTempTableFilter, setTableFilterFromTemp }) => {
    return (
        <Modal
            title="Filter"
            width={300}
            open={visible}
            onCancel={hideModal}
            footer={<>
                <Button onClick={hideModal}>Tutup</Button>
                <Button type='primary' onClick={setTableFilterFromTemp}>Terapkan</Button>
            </>}
        >
            <Form
                name="basic"
                autoComplete="off"
                layout="vertical"
            >
                <Form.Item label="Tahun Ajaran">
                    <SelectTahunAjaran
                        allowClear
                        value={values.tahun_ajaran_id}
                        onChange={(val) => {
                            setTempTableFilter("tahun_ajaran_id", val || null);
                            setTempTableFilter("semester_id", null);
                            setTempTableFilter("rombel_id", null);
                        }}
                    />
                </Form.Item>
                <Form.Item label="Semester">
                    <SelectSemester
                        allowClear
                        value={values.semester_id}
                        tahunAjaranId={values.tahun_ajaran_id}
                        disabled={!values.tahun_ajaran_id}
                        onChange={(val) => {
                            setTempTableFilter("semester_id", val || null);
                            setTempTableFilter("rombel_id", null);
                        }}
                    />
                </Form.Item>
                <Form.Item label="Rombel">
                    <SelectRombel
                        allowClear
                        value={values.rombel_id}
                        tahunAjaranId={values.tahun_ajaran_id}
                        semesterId={values.semester_id}
                        disabled={!values.tahun_ajaran_id || !values.semester_id}
                        onChange={(val) => {
                            setTempTableFilter("rombel_id", val || null);
                        }}
                    />
                </Form.Item>
                <Form.Item label="Status Notifikasi">
                    <SelectStatusNotif
                        allowClear
                        value={values.status}
                        onChange={(val) => {
                            setTempTableFilter("status", val || null);
                        }}
                    />
                </Form.Item>
                <Row gutter={[16, 16]}>
                    <Col xs={24}>
                        <Form.Item label="Periode">
                            <RangePicker
                                value={values.tgl_awal && values.tgl_akhir ? [dayjs(values.tgl_awal), dayjs(values.tgl_akhir)] : null}
                                style={{ width: '100%' }}
                                onChange={(e, val) => {
                                    if (val.length === 2 && (val[0] && val[1])) {
                                        let tglAwal = _getDate(val[0]);
                                        let tglAkhir = _getDate(val[1]);

                                        let _tglAwal = tglAwal.replace(/-/g, "").replace(/ /g, "").replace(/:/g, "");
                                        let _tglAkhir = tglAkhir.replace(/-/g, "").replace(/ /g, "").replace(/:/g, "");

                                        if (_tglAwal > _tglAkhir) {
                                            return message.warning("Periode yang dimasukkan tidak valid.");
                                        }

                                        setTempTableFilter("tgl_awal", val[0]);
                                        setTempTableFilter("tgl_akhir", val[1]);
                                    }else{
                                        setTempTableFilter("tgl_awal", null);
                                        setTempTableFilter("tgl_akhir", null);
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default ModalFilter;
